module.exports = __webpack_public_path__ + "img/tspzrz.41fb3a22.png";